var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"article-cover-img"},[_c('img',{attrs:{"width":"1200","height":"628","alt":_vm.alt,"loading":_vm.loading,"src":_vm.src,"title":_vm.alt}}),_vm._v(" "),_c('span',{staticClass:"article-cover-img__placeholder"})])}
var staticRenderFns = []

export { render, staticRenderFns }